"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
// import { scale } from "../../../utils/scale";
const scale_1 = require("../../../utils/scale");
const images_1 = require("../../../assets/images");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const ListImage_1 = __importDefault(require("./ListImage"));
const moment_1 = __importDefault(require("moment"));
const helpler_1 = require("../../../utils/helpler");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const react_redux_1 = require("react-redux");
const constants_1 = require("../../../constants");
const tooltips_1 = require("../../../components/tooltips");
const NUMBER_OF_LINE_CONTENT = 20;
const QuoteTweet = (props) => {
    const { data, type = 'HOME' } = props;
    const [showMore, setShowMore] = (0, react_1.useState)(true);
    const [numberlineContent, setNumberlineContent] = (0, react_1.useState)(0);
    const handleShowMore = () => {
        setShowMore(true);
    };
    const dataUser = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile, react_redux_1.shallowEqual);
    const dataListFollow = (0, react_redux_1.useSelector)((state) => state?.listFollowReducer?.listFollow, react_redux_1.shallowEqual);
    const dataListBlock = (0, react_redux_1.useSelector)((state) => state?.listBlockReducer?.listBlock, react_redux_1.shallowEqual);
    const dataListMute = (0, react_redux_1.useSelector)((state) => state?.listMuteReducer?.listMute, react_redux_1.shallowEqual);
    const checkDataQuoteTweet = () => {
        let idFollow = dataListFollow.some((item) => item == data?.userId);
        let idBlock = dataListBlock.some((item) => item == data?.userId);
        let idMute = dataListMute.some((item) => item == data?.userId);
        if (data?.isDeleted == 1) {
            return '投稿者によって削除された投稿です';
        }
        else if (data?.publicationRange == 1 &&
            !idFollow &&
            data?.userId != dataUser?.user_id) {
            return `フォロワー限定の投稿です。\nフォローして投稿を見てみましょう。`;
        }
        else if (idBlock) {
            return `あなたがブロックしたユーザーの投稿です`;
        }
        else if (idMute) {
            return `あなたがミュートしたユーザーの投稿です`;
        }
        return false;
    };
    const textTimeCreate = () => {
        const currentTime = (0, moment_1.default)();
        const createTime = (0, moment_1.default)(data?.createdAt);
        const duration = moment_1.default.duration(currentTime.diff(createTime));
        const minutesDiff = +duration.asMinutes().toFixed(0);
        const hDiff = +duration.asHours().toFixed(0);
        const sameDay = currentTime.isSame(createTime, 'day');
        if (!sameDay) {
            return (0, moment_1.default)(data?.createdAt).format('YYYY/MM/DD');
        }
        else if (minutesDiff <= 1) {
            return '1分以内';
        }
        else if (minutesDiff < 60 && minutesDiff > 1) {
            return `${minutesDiff}分前`;
        }
        else if (hDiff < 24 && hDiff >= 1) {
            return `${hDiff}時間前`;
        }
        return (0, moment_1.default)(data?.createdAt).format('YYYY/MM/DD');
    };
    const navigateToUserProfile = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: data.userHandle,
            },
        });
    };
    return (react_1.default.createElement(react_native_1.View, { style: [styles.viewQuoteTweet, type == 'DETAIL' && { width: (0, scale_1.scale)(343) }] },
        react_1.default.createElement(react_native_1.TouchableOpacity, { style: { flexDirection: 'row' }, onPress: () => navigateToUserProfile() },
            react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(28) } },
                react_1.default.createElement(react_native_1.Image, { source: data?.thumbnailUrl ? { uri: data?.thumbnailUrl } : images_1.images.AvatarDefaul, style: {
                        height: (0, scale_1.scale)(20),
                        width: (0, scale_1.scale)(20),
                        borderRadius: (0, scale_1.scale)(10),
                    } })),
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: 'row',
                    width: type == 'DETAIL' ? (0, scale_1.scale)(290) : (0, scale_1.scale)(240),
                    justifyContent: 'space-between',
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "600", numberOfLines: 1, style: styles.textName }, data?.nickname || constants_1.DEFAULT_NAME),
                react_1.default.createElement(react_native_1.View, { style: { marginLeft: (0, scale_1.scale)(24), marginTop: (0, scale_1.scale)(2) } },
                    react_1.default.createElement(tooltips_1.DateTimeTooltip, { title: (0, moment_1.default)(data?.createdAt).format('YYYY/MM/DD HH:mm') }, `${(0, helpler_1.stringToDateFormat)(data?.createdAt)} `)))),
        checkDataQuoteTweet() ? (react_1.default.createElement(react_native_1.View, { style: {
                width: (0, scale_1.scale)(265),
                height: (0, scale_1.scale)(45),
                borderWidth: 1,
                borderColor: '#DDDDDD',
                borderRadius: 3,
                backgroundColor: '#EEEEEE',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: (0, scale_1.scale)(12),
            } },
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(14),
                    lineHeight: (0, scale_1.moderateScale)(21),
                    color: '#292A33',
                    width: (0, scale_1.scale)(241),
                } }, checkDataQuoteTweet()))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(15),
                    lineHeight: (0, scale_1.moderateScale)(23),
                    color: '#292A33',
                    marginTop: (0, scale_1.scale)(8),
                }, numberOfLines: !showMore ? NUMBER_OF_LINE_CONTENT : undefined, onLayout: (event) => {
                    let numberline = event.nativeEvent.layout.height / (0, scale_1.moderateScale)(23);
                    if (numberline >= NUMBER_OF_LINE_CONTENT + 1 && numberlineContent < NUMBER_OF_LINE_CONTENT) {
                        setShowMore(false);
                        setNumberlineContent(numberline);
                    }
                } }, data?.content?.split(helpler_1.hashtagRegex).map((string, index) => {
                if (string.match(helpler_1.hashtagRegex)) {
                    return (react_1.default.createElement(react_native_1.Text, { key: index, style: { color: '#007AFF' }, onPress: () => {
                            (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                screen: Routes_1.default.HASHTAG_DETAIL,
                                params: {
                                    hashtag: string?.slice(1),
                                    typeScreen: 0,
                                    typeHashTag: 3,
                                },
                            });
                        } }, string));
                }
                else {
                    return react_1.default.createElement(react_native_1.Text, { key: index }, string);
                }
            })),
            !showMore && numberlineContent > 5 && (react_1.default.createElement(CustomText_1.default, { onPress: handleShowMore, weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(12),
                    lineHeight: (0, scale_1.moderateScale)(18),
                    color: '#007AFF',
                } }, "\u7D9A\u304D\u3092\u898B\u308B")),
            react_1.default.createElement(ListImage_1.default, { data: data?.images, type: type == 'HOME' ? 'QuoteTweet' : 'QuoteTweetDetail' })))));
};
const styles = react_native_1.StyleSheet.create({
    viewQuoteTweet: {
        width: (0, scale_1.scale)(290),
        borderWidth: 1,
        borderColor: '#DDDDDD',
        borderRadius: (0, scale_1.scale)(5),
        paddingHorizontal: (0, scale_1.scale)(12),
        paddingVertical: (0, scale_1.scale)(12),
        backgroundColor: '#FEFEFE'
    },
    textName: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        maxWidth: (0, scale_1.scale)(155),
    },
    textTime: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(15),
        fontWeight: '200',
        color: '#7C7C7C',
        marginLeft: (0, scale_1.scale)(24),
        marginTop: (0, scale_1.scale)(2),
    },
    View: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
});
exports.default = QuoteTweet;
